import { useState } from "react";
import { sanitizeMarkup } from "../../util/sanitization/sanitize-html";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const employerFaqList = [
  {
    question: "What kind of talent can I expect to reach?",
    answer:
      "Instant Teams is powered by a highly engaged community of remote professionals, with a strong focus on <b>skilled military spouses and military-connected talent</b>. At the same time, our platform attracts a diverse array of experienced remote workers across CX and EX roles.<br/><br/>The result is access to a resilient, high-performing talent pool—where employers consistently see retention, engagement, and performance rates that outpace industry averages.",
  },
  {
    question: "How do I maximize visibility for my job posts?",
    answer:
      "You can further amplify your hiring efforts through <b>marketing boosts</b> and participation in our <b>community activations</b>—both designed to expand your reach and drive deeper engagement with the military spouse talent community.",
  },
  {
    question: "What industries do candidates specialize in?",
    answer:
      "Our partners regularly hire talent with backgrounds in <b>customer experience (CX), healthcare, fintech, retail, e-commerce, government contracting, cyber, and more</b>. Our talent community brings diverse skills from varied career paths, making them adaptable and high-performing.",
  },
  {
    question: "How do I track applications?",
    answer:
      "Our job listings connect directly to your ATS, so candidates flow seamlessly into your existing system. You can also track performance from our platform, including the number of <b>views and clicks</b> each post generates, giving you clear visibility into engagement and reach.",
  },
  {
    question: "What other services do you provide as a Total Experience Marketplace?",
    answer:
      "We solve the two hardest problems in business today: finding high-performing, resilient talent and capturing the attention of a fiercely loyal, hard-to-reach audience.<br/><br/>Our job board is just one part of the Instant Teams marketplace. We deploy onshore, remote CX &amp; EX teams that consistently outperform industry benchmarks in speed, quality, and retention—powered by highly skilled, military-connected professionals.<br/><br/>Through our platform, we also provide brand integration opportunities through our annual calendar of virtual and in-person community events—creating a full-spectrum solution for both talent acquisition and customer engagement.",
  },
];

export default function GeneralInfoCategoryPost_NewUI({ faqList }) {
  const [openIndex, setOpenIndex] = useState(null);
  const items = faqList || employerFaqList;

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="flex flex-col gap-3 w-full">
      {items.map((faq, index) => {
        const isOpen = openIndex === index;
        return (
          <div
            key={index}
            className={`rounded-xl border transition-all duration-300 ease-in-out ${
              isOpen
                ? "border-instant-teams-teal-L1 bg-white shadow-md"
                : "border-gray-200 bg-white hover:border-instant-teams-teal-L3 hover:shadow-sm"
            }`}
          >
            <button
              type="button"
              onClick={() => handleToggle(index)}
              className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
            >
              <span
                className={`text-[15px] font-semibold leading-snug transition-colors duration-200 ${
                  isOpen
                    ? "text-instant-teams-teal-D1"
                    : "text-instant-teams-blue-Main"
                }`}
              >
                {faq.question}
              </span>
              <span
                className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all duration-300 ${
                  isOpen
                    ? "bg-instant-teams-teal-Main text-white rotate-180"
                    : "bg-instant-teams-blue-BLUE text-instant-teams-teal-Main"
                }`}
              >
                <FontAwesomeIcon icon={faChevronDown} className="text-xs" />
              </span>
            </button>

            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                isOpen ? "max-h-[600px] opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <div
                className="faq-answer-content px-6 pb-5 text-sm leading-relaxed text-gray-600"
                onClick={(e) => {
                  if (e.target && e.target.closest && e.target.closest("a")) {
                    e.stopPropagation();
                  }
                }}
                dangerouslySetInnerHTML={sanitizeMarkup(faq.answer)}
              />
            </div>
          </div>
        );
      })}

      <style>{`
        .faq-answer-content b { color: #1A5060; font-weight: 600; }
        .faq-answer-content a { color: #2C85A0; text-decoration: underline; text-underline-offset: 2px; }
        .faq-answer-content a:hover { color: #1A5060; }
      `}</style>
    </div>
  );
}
